import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "modern-normalize";
import App from "./components/App/App.jsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store.js";
import { PersistGate } from "redux-persist/integration/react";

import TourManager from "./components/TourManager/TourManager.jsx";
import { TourProvider } from "@reactour/tour";
import { showToast } from "./utils/showToast.js";

let extensionConflictWarningShown = false;

function handleChunkError(event) {
  const error = event.reason || event.error;

  if (!error) return;

  // Перевірка на помилку динамічного імпорту
  if (
    error?.message?.includes("Failed to load module") ||
    error?.message?.includes("Failed to fetch dynamically imported module") ||
    error?.message?.includes("Failed to load module script") ||
    error?.message?.includes("Failed to fetch dynamically imported module") ||
    error?.message?.includes("Importing a module script failed")
  ) {
    console.warn("Chunk loading error. Reloading...");
    window.location.reload(); // Перезавантаження сторінки
    return;
  }

  // Конфлікт розширення браузера з DOM (Grammarly, перекладачі, блокувальники реклами тощо)
  if (
    error.name === "NotFoundError" &&
    error.message?.includes("removeChild")
  ) {
    console.warn("Possible browser extension conflict:", error);

    if (!extensionConflictWarningShown) {
      extensionConflictWarningShown = true;
      showToast(
        {
          title: "Конфлікт з розширенням браузера",
          description:
            "Відкрийте сторінку в режимі інкогніто або вимкніть розширення.",
        },
        "error"
      );
    }
  }
}

window.addEventListener("unhandledrejection", handleChunkError);
window.addEventListener("error", handleChunkError);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <TourProvider
            // key={`${location?.pathname}-${section}`}
            steps={[]}
            showCloseButton={false}
            showNavigation={false}
            showDots={false}
            showBadge={false}
            onClickMask={() => {}}
            styles={{
              popover: base => ({
                ...base,
                transition: "none",
                transform: "none",
              }),
            }}
            disableInteraction
          >
            <TourManager />

            <App />
          </TourProvider>
          {/* <App /> */}
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </StrictMode>
);
